import { put, call, takeLatest, all, select } from "redux-saga/effects";
import * as Pricing from "../api/pricingApi";
import { proxyInfo } from "../api/epicApi";//, getEvisitEligibility, getZipnosisEvisitUrl
import * as types from "../constants/actionTypes";
import { logAPI, logUI } from "../api/andyliticsApi";
import * as tools from '../helpers/Tools';



export default function* myChartDataTileSaga() {
    yield takeLatest(types.MYCHART_DATA_TILE_TOUCHED, handleDataTileTouched);
}


function* handleDataTileTouched(data) {
    try {
        console.info(`myChartDataTileSaga handleDataTileTouched `,data);
        yield put({ type: types.MYCHART_DATA_TILE_TOUCHED_SUCCESS, data });
    } catch (e) {
        logAPI("MBHWeb.Saga.myChartDataTile.handleDataTileTouched.Failure", new Date(), null, e);
    }
}

